import axios from '@/services/api'

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const fetchEvents = (query = '') => {
	const url = `/api/events?${query}`
	return axios.get(url)
}

/**
 * @param {Number} id
 * @param {String} queryString
 *
 * @returns {Promise<Object>}
 */
export const getActionFiles = (id, queryString) => {
	const url = `/api/event-action-files?action_id=${id}&${queryString}`
	return axios.get(url)
}


/**
 * @param {Number} id
 * @param {String} queryString
 *
 * @returns {Promise<Object>}
 */
export const getActionLinks = (id, queryString) => {
	const url = `/api/event-action-links?action_id=${id}${queryString}`
	return axios.get(url)
}


/**
 *
 * @returns {Promise<Object>}
 */
export const fetchEventCategories = (query) => {
	const url = `/api/event-categories`
	return axios.get(url, {params: query})
}


/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const fetchPartners = (query = '') => {
	const url = `/api/partners?${query}`
	return axios.get(url)
}

/**
 * @param {number} eventId
 * @param {object} query
 *
 * @returns {Promise<Object>}
 */
export const getEvent = (eventId, query = {} ) => {
	const url = `/api/events/${eventId}`
	return axios.get(url, { params: query})
}

/**
 * @param {object} query
 *
 * @returns {Promise<Object>}
 */
export const getAgendaEvent = ( query = {} ) => {
	const url = `/api/event-agenda?${query}`
	return axios.get(url)
}

/**
 * @param {object} data
 *
 * @returns {Promise<Object>}
 */
export const followEvent = ( data = {} ) => {
	const url = `/api/event-users`
	return axios.post(url, data)
}

/**
 * @param {number} eventId
 *
 * @returns {Promise<Object>}
 */
export const unfollowEvent = ( eventId ) => {
	const url = `/api/event-users/${eventId}`
	return axios.delete(url)
}

/**
 * @param {Object} query
 *
 * @returns {Promise<Object>}
 */
export const getAttendeesEvent = ( query ) => {
	const url = `/api/users?${query}`
	return axios.get(url)
}

/**
 *
 * @returns {Promise<Object>}
 */
export const getEventSession = ( id ) => {
	const url = `/api/event-agenda/${id}?expand=session_description,session_location,uploads,speakers,session_question_answers`
	return axios.get(url)
}

/**
 *
 * @returns {Promise<Object>}
 */
export const getAttendeeEvent = ( id ) => {
	const url = `/api/users/${id}?expand=qr,public,follow_note,follow_status,private`
	return axios.get(url)
}


/**
 * @param {object} data
 *
 * @returns {Promise<Object>}
 */
export const addToSchedule = ( data = {} ) => {
	const url = `/api/event-users-schedule`
	return axios.post(url, data)
}

/**
 * @param {number} eventId
 *
 * @returns {Promise<Object>}
 */
export const removeFromSchedule = ( eventId ) => {
	const url = `/api/event-users/${eventId}`
	return axios.delete(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addSessionAgendaQuestion = (data = {}) => {
	const url = '/api/session-question-answers'
	return axios.post(url, data)
}

/**
 * @param {Object} sessionId
 *
 * @returns {Promise<Object>}
 */
export const getSessionQuestions = ({sessionId, page}) => {
	const url = `/api/session-question-answers?session_id=${sessionId}&page=${page}`
	return axios.get(url)
}

/**
 * @param {number} answerId
 *
 * @returns {Promise<Object>}
 */
export const upvoteSessionQuestion = (answerId) => {
	const url = '/api/session-question-answers-upvote'
	return axios.post(url, {session_question_answer_id: answerId})
}

/**
 * @param {number} answerId
 *
 * @returns {Promise<Object>}
 */
export const deleteUpvoteSessionQuestion = (answerId) => {
	const url = `/api/session-question-answers-upvote/${answerId}`
	return axios.delete(url)
}
